import { useEffect, useState, useMemo } from "react";
import { apiRequest } from "../../network/apiClient";
import { API_ENDPOINTS } from "../../api/apiEndpoints";

export const useAccInventoryYours = (page, pageSize, selectedStatus, filters, searchName, sortField, sortOrder) => {
    const [data, setData] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [totalAccounts, setTotalAccounts] = useState(0);
    const [accountStatusCount, setAccountStatusCount] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [absoluteTotal, setAbsoluteTotal] = useState(0);

    const userID = localStorage.getItem("userId")

    useEffect(() => {
        const fetchData = async () => {
            setIsLoading(true);
            try {
                const AccountStatus = [];
                const queryParams = new URLSearchParams({
                    user_id: userID,
                    page: page.toString(),
                    page_size: pageSize.toString()
                })
                if(selectedStatus) {
                    AccountStatus.push(selectedStatus)
                    
                }
                if (filters?.leadStatus?.length) {
                    AccountStatus.push(...filters.churnlikelihood)
                }
                AccountStatus.forEach(status => {
                    queryParams.append("churn_profile", status);
                });
                if (filters?.churnlikelihood?.length) {
                    filters.churnlikelihood.forEach(product => {
                        queryParams.append("churn_profile", product);
                    });
                }
                // Handle name search
                if(searchName){
                    queryParams.append("name", searchName);
                }
                // Handle product selection
                if (filters?.products?.length) {
                    filters.products.forEach(product => {
                        queryParams.append("products", product);
                    });
                }
                // Handle relationship selection
                if (filters?.relationship?.length) {
                    filters.relationship.forEach(product => {
                        queryParams.append("relationship", product);
                    });
                }
                // Handle lead source selection
                if (filters?.profilename?.length) {
                    filters.profilename.forEach(source => {
                        queryParams.append("profile_name", source);
                    });
                }
                // Handle sorting
                if (sortField) {
                    queryParams.append("sort_by", sortField);
                    queryParams.append("sort_order", sortOrder || 'desc');
                }

                const result = await apiRequest(`${API_ENDPOINTS.GET_ACCOUNTS.YOURS_INVENTORY}?${queryParams.toString()}`, 'GET');
                
                // Assign data to state
                if(result) {
                    setData(result.data);
                    setTotalPages(result.total_pages);
                    setTotalAccounts(result.total_rows);
                    setAccountStatusCount(result.account_churn_counts);
                    setAbsoluteTotal(result.absolute_total);
                }else{
                    console.error("Failed to fetch lead inventory:", result.error);
                }
                setIsLoading(false);
            } catch (error) {
                setIsLoading(false);
            }
        };

        fetchData();
    }, [page, pageSize, selectedStatus, filters, searchName, sortField, sortOrder]);

    const refetch = () => {
        setIsLoading(true);
        const fetchData = async () => {
            try {
                const AccountStatus = [];
                const queryParams = new URLSearchParams({
                    user_id: userID,
                    page: page.toString(),
                    page_size: pageSize.toString()
                })
                if(selectedStatus) {
                    AccountStatus.push(selectedStatus)
                }
                if (filters?.leadStatus?.length) {
                    AccountStatus.push(...filters.churnlikelihood)
                }
                AccountStatus.forEach(status => {
                    queryParams.append("churn_profile", status);
                });
                if (filters?.churnlikelihood?.length) {
                    filters.churnlikelihood.forEach(product => {
                        queryParams.append("churn_profile", product);
                    });
                }
                if(searchName){
                    queryParams.append("name", searchName);
                }
                if (filters?.products?.length) {
                    filters.products.forEach(product => {
                        queryParams.append("products", product);
                    });
                }
                if (filters?.relationship?.length) {
                    filters.relationship.forEach(product => {
                        queryParams.append("relationship", product);
                    });
                }
                if (filters?.profilename?.length) {
                    filters.profilename.forEach(source => {
                        queryParams.append("profile_name", source);
                    });
                }
                // Handle sorting
                if (sortField) {
                    queryParams.append("sort_by", sortField);
                    queryParams.append("sort_order", sortOrder || 'desc');
                }

                const result = await apiRequest(`/account-inventory-table-yours?${queryParams.toString()}`, 'GET');
                
                if(result) {
                    setData(result.data);
                    setTotalPages(result.total_pages);
                    setTotalAccounts(result.total_rows);
                    setAccountStatusCount(result.account_churn_counts);
                    setAbsoluteTotal(result.absolute_total);
                }else{
                    console.error("Failed to fetch lead inventory:", result.error);
                }
                setIsLoading(false);
            } catch (error) {
                setIsLoading(false);
            }
        };
        fetchData();
    };

    return { data, totalPages, totalAccounts, accountStatusCount, isLoading, absoluteTotal, refetch};
};
